export class UIBridge {
  constructor() {
    this.target = new EventTarget();
  }

  /**
   * @param {string} eventName
   * @param {(event: CustomEvent) => void} listener
   */
  on(eventName, listener) {
    this.target.addEventListener(eventName, listener);
  }

  /**
   * @param {string} eventName
   * @param {(event: CustomEvent) => void} listener
   */
  off(eventName, listener) {
    this.target.removeEventListener(eventName, listener);
  }

  emit(eventName, detail = {}) {
    this.target.dispatchEvent(new CustomEvent(eventName, { detail }));
  }
}
